export default __webpack_public_path__ + "static/media/pugar.c814ca56.png";